import { getStatusColorClass, formatDateCustomFormate, formatToINR } from "../Utils/util";
import moment from "moment";
import { config } from "../Config/config";
import { CiStopwatch } from "react-icons/ci";
import { CustomInputField } from "../Common/FormField";
import { IoIosRefresh } from "react-icons/io";
import { FaRegEye } from "react-icons/fa";
import { actionIcon } from "../img";
const StatusColumn = ({ status }) => (
	<span className={getStatusColorClass(status)}>{status}</span>
);

const AgentBadge = ({ item }) => {
	if (!item?.agentId && !item?.isAgentBooking && item?.bookingMethod !== "agent") return null;
	const fullAgentName =
		typeof item.agentId === "object" && item.agentId !== null
			? item.agentId.companyName || item.agentId.fullName || item.agentId.contactPersonName
			: item.agentId || "Agent";

	const getShortName = (name) => {
		if (!name) return "";
		const words = name.trim().split(/\s+/);
		if (words.length > 2) {
			return words.slice(0, 2).join(" ") + "...";
		}
		return name;
	};

	const displayName = getShortName(fullAgentName);

	return (
		<p className="text-[11px] text-[#696A6A] font-normal mt-0.5 whitespace-nowrap" title={`Agent: ${fullAgentName}`}>
			<span className="text-gray-400">Agent: </span>
			<span className="text-gray-700 font-medium">{displayName}</span>
		</p>
	);
};
const columnsPlace = [
	{
		key: "name",
		label: "Place Name",
		render: (item) => item.name,
	},
	{
		key: "PlaceImage",
		label: "Place Image",
		render: (item) => (
			<div className="rounded-lg w-20 h-20 overflow-hidden">
				<img
					src={config.base.awsUrl + item.frontImage}
					alt="PlaceImage"
					className="w-full h-full object-cover"
				/>
			</div>
		),
	},
	{
		key: "openingTime",
		label: "Time",
		render: (item) => item.openingTime + ' - ' + item.closingTime,
	},
	{
		key: "chargesForAdult",
		label: "Adult Charge",
		render: (item) => formatToINR(item.chargesForAdult),
	},
	{
		key: "chargesForChild",
		label: "Child Charge",
		render: (item) => formatToINR(item.chargesForChild),
	}
];

const columnsPlaceSettingOn = [
	{
		key: "date",
		label: "Date",
		render: (item) => moment(item.bookingOn).format("DD-MM-YYYY"),
	},
	{
		key: "note",
		label: "Note",
		render: (item) => item.note,
	},
];

const columnsPlaceSettingOff = [
	{
		key: "date",
		label: "Date",
		render: (item) => moment(item.bookingOff).format("DD-MM-YYYY"),
	},
	{
		key: "note",
		label: "Note",
		render: (item) => item.note,
	},
];

const columnsPlaceBookingOff = [
	{
		key: "date",
		label: "Date",
		render: (item) => moment(item.startDate).format("DD-MM-YYYY"),
	},
	{
		key: "note",
		label: "Note",
		render: (item) => item.note,
	},
];

const columnsPackageCategory = [
	{
		key: "name",
		label: "Category Name",
		render: (item) => item.name,
	},
	{
		key: "CategoryImage",
		label: "Image",
		render: (item) => (
			<div className="rounded-lg w-20 h-20 overflow-hidden">
				<img
					src={config.base.awsUrl + item.image}
					alt="CategoryImage"
					className="w-full h-full object-cover"
				/>
			</div>
		),
	},
];

const columnsPackage = [
	{
		key: "number",
		label: "Number",
		render: (item) => item.packageNumber,
	},
	{
		key: "name",
		label: "Package Name",
		render: (item) => item.name,
	},
	{
		key: "PackageImage",
		label: "Package Image",
		render: (item) => (
			<div className="rounded-lg w-20 h-20 overflow-hidden">
				<img
					src={config.base.awsUrl + item.frontImage}
					alt="PackageImage"
					className="w-full h-full object-cover"
				/>
			</div>
		),
	},
	{
		key: "day",
		label: "Day",
		render: (item) => item.totalDayOfPackage,
	},
	{
		key: "chargesForAdult",
		label: "Adult Charge",
		render: (item) => formatToINR(item.chargesForAdult),
	},
	{
		key: "chargesForChild",
		label: "Child Charge",
		render: (item) => formatToINR(item.chargesForChild),
	},
];

const columnsBooking = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="flex gap-1 items-center text-[12px] text-[#696A6A]"><CiStopwatch className="text-sm" /> {formatDateCustomFormate(item.bookingDate, 'DD-MM-YYYY ddd | hh:mm A')}</p>
				</div>
			</div>
		),
	},
	{
		key: "visitingDate",
		label: "Visiting Date",
		render: (item) => moment(item.visitingDate).format("DD-MM-YYYY"),
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => (
			<div>
				<p>{item.bookingId}</p>
				<AgentBadge item={item} />
			</div>
		),
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.totalAmount + item.serviceCharge),
	},
	{
		key: "status",
		label: "Status",
		render: (item) => item.bookingStatus === 'pending' && item.cancelBy ? <StatusColumn status="Cancel By User" /> : <StatusColumn status={item.bookingStatus} />,
	},
	{
		key: "staffWorking",
		label: "Staff Working",
		render: (item) => (item.workingStaffId) ? (item.workingStaffId.firstName + " " + item.workingStaffId.lastName) : "",
	},
	{
		key: "ConfirmBy",
		label: "Confirm By",
		render: (item) => (item.confirmBy) ? (item.confirmBy.firstName + " " + item.confirmBy.lastName) : "",
	},
];

const columnsBookingHistory = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="flex gap-1 items-center text-[12px] text-[#696A6A]"><CiStopwatch className="text-sm" /> {formatDateCustomFormate(item.bookingDate, 'DD-MM-YYYY ddd | hh:mm A')}</p>
				</div>
			</div>
		),
	},
	{
		key: "visitingDate",
		label: "Visiting Date",
		render: (item) => moment(item.visitingDate).format("DD-MM-YYYY"),
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => (
			<div>
				<p>{item.bookingId}</p>
				<AgentBadge item={item} />
			</div>
		),
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.finalAmount),
	},
	{
		key: "status",
		label: "Status",
		render: (item) => item.bookingStatus === 'pending' && item.cancelBy ? <StatusColumn status="Cancel By User" /> : item.bookingStatus === 'cancelConfirm' ? <StatusColumn status="SOU Cancel Confirm" /> : item.specificCancelStatus === 'cancel' ? <StatusColumn status="Specific Cancel" /> : item.specificCancelStatus === 'cancelConfirm' ? <StatusColumn status="Cancel Confirm" /> : item.bookingStatus === 'refundPending' ? <StatusColumn status="Refund Pending" /> : item.bookingStatus === 'refunded' ? <StatusColumn status="Refunded" /> : <StatusColumn status={item.bookingStatus} />,
	},
	{
		key: "staffWorking",
		label: "Staff Working",
		render: (item) => (item.workingStaffId) ? (item.workingStaffId.firstName + " " + item.workingStaffId.lastName) : "",
	},
	{
		key: "ConfirmBy",
		label: "Confirm By",
		render: (item) => (item.confirmBy) ? (item.confirmBy.firstName + " " + item.confirmBy.lastName) : "",
	},
];

const columnsOtherSOUBooking = (handleRefundClick) => [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="flex gap-1 items-center text-[12px] text-[#696A6A]"><CiStopwatch className="text-sm" /> {formatDateCustomFormate(item.visitingDate, 'DD-MM-YYYY ddd | hh:mm A')}</p>
				</div>
			</div>
		),
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "otherBookingIds",
		label: "Other SOU Booking IDs",
		render: (item) => (
			<div className="flex flex-col gap-2 min-w-[200px]">
				{item.otherBookingIds?.map((id, index) => (
					<div key={index} className="flex flex-col border-b border-gray-200 last:border-b-0 pb-1.5 last:pb-0">
						<div className="flex justify-between items-center">
							<span className="text-[14px] font-medium text-primary">{id.souBookingId}</span>
							<span className={`text-[11px] px-1.5 py-0.5 rounded ${id.Status === 'Confirm' ? 'bg-green-100 text-green-700' : id.Status === 'Cancel' ? 'bg-red-100 text-red-700' : 'bg-yellow-100 text-yellow-700'}`}>{id.Status}</span>
						</div>
						<div className="flex gap-3 text-[12px] mt-0.5">
							<span className="text-gray-500">Amt: <span className="font-semibold text-gray-800">₹{id.bookingAmount || 0}</span></span>
							{Number(id.refundedAmount) > 0 && (
								<span className="text-green-600 font-medium">Refunded: ₹{id.refundedAmount}</span>
							)}
						</div>
					</div>
				))}
			</div>
		),
	},
	{
		key: "visitingDate",
		label: "Visiting Date",
		render: (item) => moment(item.visitingDate).format("DD-MM-YYYY"),
	},
	{
		key: "action",
		label: "Action",
		render: (item) => (
			<div className="flex flex-col gap-2">
				{item.otherBookingIds?.map((id, index) => (
					<button
						key={index}
						onClick={() => handleRefundClick(item, id)}
						className="bg-primary cursor-pointer w-7 h-7 rounded-lg flex justify-center items-center hover:bg-opacity-90 transition-all"
						title="Process Refund"
					>
						<FaRegEye className="text-white text-xs" />
					</button>
				))}
			</div>
		)
	}
];

const columnsAllBooking = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="flex gap-1 items-center text-[12px] text-[#696A6A]"><CiStopwatch className="text-sm" /> {formatDateCustomFormate(item.bookingDate, 'DD-MM-YYYY ddd | hh:mm A')}</p>
				</div>
			</div>
		),
	},
	{
		key: "visitingDate",
		label: "Visiting Date",
		render: (item) => moment(item.visitingDate).format("DD-MM-YYYY"),
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => (
			<div>
				<p>{item.bookingId}</p>
				<AgentBadge item={item} />
			</div>
		),
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.finalAmount),
	},
	{
		key: "status",
		label: "Status",
		render: (item) => item.bookingStatus === 'pending' && item.cancelBy ? <StatusColumn status="Cancel By User" /> : item.bookingStatus === 'cancelConfirm' ? <StatusColumn status="SOU Cancel Confirm" /> : item.bookingStatus === 'refundPending' ? <StatusColumn status="Refund Pending" /> : item.bookingStatus === 'refunded' ? <StatusColumn status="Refunded" /> : <StatusColumn status={item.bookingStatus} />,
	},
	{
		key: "specificCancelStatus",
		label: "Specific Cancel Status",
		render: (item) => item.specificCancelStatus === 'cancel' ? <StatusColumn status="Specific Cancel" /> : item.specificCancelStatus === 'cancelConfirm' ? <StatusColumn status="Cancel Confirm" /> : '',
	},
	{
		key: "staffWorking",
		label: "Staff Working",
		render: (item) => (item.workingStaffId) ? (item.workingStaffId.firstName + " " + item.workingStaffId.lastName) : "",
	},
	{
		key: "ConfirmBy",
		label: "Confirm By",
		render: (item) => (item.confirmBy) ? (item.confirmBy.firstName + " " + item.confirmBy.lastName) : "",
	},
];

const columnsConfirmBooking = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="flex gap-1 items-center text-[12px] text-[#696A6A]"><CiStopwatch className="text-sm" /> {formatDateCustomFormate(item.bookingDate, 'DD-MM-YYYY ddd | hh:mm A')}</p>
				</div>
			</div>
		),
	},
	{
		key: "visitingDate",
		label: "Visiting Date",
		render: (item) => moment(item.visitingDate).format("DD-MM-YYYY"),
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => (
			<div>
				<p>{item.bookingId}</p>
				<AgentBadge item={item} />
			</div>
		),
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.finalAmount),
	},
	{
		key: "status",
		label: "Status",
		render: (item) => item.bookingStatus === 'pending' && item.cancelBy ? <StatusColumn status="Cancel By User" /> : <StatusColumn status={item.bookingStatus} />,
	},
	{
		key: "ConfirmBy",
		label: "Confirm By",
		render: (item) => (item.confirmBy) ? (item.confirmBy.firstName + " " + item.confirmBy.lastName) : "",
	},
];

const columnsBookingCancel = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="text-[12px] text-[#696A6A]">{item.userId?.email}</p>
				</div>
			</div>
		),
	},
	{
		key: "phoneNo",
		label: "Mobile No",
		render: (item) => item.phoneNo,
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "bookingDate",
		label: "Booking Date",
		render: (item) => formatDateCustomFormate(item.bookingDate, 'DD/MM/YYYY'),
	},
	{
		key: "cancelDate",
		label: "Cancel Date",
		render: (item) => formatDateCustomFormate(item.cancelDate, 'DD/MM/YYYY'),
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.finalAmount),
	},
	{
		key: "cancelBy",
		label: "Cancel By",
		render: (item) => {
			if (item.cancelByStaff) {
				return (item?.cancelByStaff?.firstName || "") + " " + (item?.cancelByStaff?.lastName || "");
			}
			if (item.isAgentBooking || item.agentId) {
				return item?.agentId?.companyName || item?.agentId?.contactPersonName || "Agent";
			}
			return "";
		},
	},
	{
		key: "souNo",
		label: "SOU Phone Number",
		render: (item) => item.souLoginNumber,
	},
	{
		key: "status",
		label: "Status",
		render: (item) => {
			if (item.isCancelByStaff) {
				return <StatusColumn status="Cancel By Admin" />;
			}
			if (item.isAgentBooking || item.agentId) {
				return <StatusColumn status="Cancel By Agent" />;
			}
			return <StatusColumn status="Cancel By User" />;
		},
	}
];

const columnsBookingCancelConfirm = (checkSOUBookingStatus) => [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="text-[12px] text-[#696A6A]">{item.phoneNo}</p>
				</div>
			</div>
		),
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "bookingDate",
		label: "Booking Date",
		render: (item) => formatDateCustomFormate(item.bookingDate, 'DD/MM/YYYY'),
	},
	{
		key: "cancelDate",
		label: "Cancel Date",
		render: (item) => formatDateCustomFormate(item.cancelDate, 'DD/MM/YYYY'),
	},
	{
		key: "souCancelDate",
		label: "SOU Cancel Date",
		render: (item) => (item.SOUCancelDate) ? formatDateCustomFormate(item.SOUCancelDate, 'DD/MM/YYYY') : '-',
	},
	// {
	// 	key: "refundDate",
	// 	label: "Refund Date",
	// 	render: (item) => (item.expectRefundDate)?formatDateCustomFormate(item.expectRefundDate, 'DD/MM/YYYY'):'-',
	// },
	{
		key: "refundableAmount",
		label: "Refundable Amount",
		render: (item) => {
			// if (Array.isArray(item.SOUCancelDetail) && item.SOUCancelDetail.length > 0) {
			// 	return item.SOUCancelDetail.map((d, i) => (
			// 		<p key={i}>{formatToINR(d.refundableAmount)}</p>
			// 	));
			// }

			return (
				<p>
					{formatToINR(item.refundableAmount > 0 ? item.refundableAmount : item.customerRefundableAmount)}
				</p>
			);
		},
	},
	{
		key: "bank",
		label: "Bank",
		render: (item) => item?.souBookingBankAccount?.bankName,
	},
	{
		key: "cancelBy",
		label: "cancel By",
		render: (item) => (item.SOUcancelBy) ? (item?.SOUcancelBy?.firstName + " " + item?.SOUcancelBy?.lastName) : "",
	},
	{
		key: "status",
		label: "Status",
		render: (item) => <StatusColumn status="SOU Cancel Confirm" />,
	},
];

const columnsBookingRefundPending = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="text-[12px] text-[#696A6A]">{item.userId?.email}</p>
				</div>
			</div>
		),
	},
	{
		key: "phoneNo",
		label: "Mobile No",
		render: (item) => item.phoneNo,
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "bookingDate",
		label: "Booking Date",
		render: (item) => formatDateCustomFormate(item.bookingDate, 'DD/MM/YYYY'),
	},
	{
		key: "cancelDate",
		label: "Cancel Date",
		render: (item) => item.cancelDate ? formatDateCustomFormate(item.cancelDate, 'DD/MM/YYYY') : '-',
	},
	{
		key: "refundDate",
		label: "Refund Date",
		render: (item) => item.expectRefundDate ? formatDateCustomFormate(item.expectRefundDate, 'DD/MM/YYYY') : '-',
	},
	{
		key: "refundBy",
		label: "Refund By",
		render: (item) => (item.moveToRefundBy) ? (item?.moveToRefundBy?.firstName + " " + item?.moveToRefundBy?.lastName) : "",
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.finalAmount),
	},
	{
		key: "bank",
		label: "Bank",
		render: (item) => item.souBookingBankAccount?.bankName,
	},
	{
		key: "status",
		label: "Status",
		render: (item) => <StatusColumn status="Refund Pending" />,
	}
];

const columnsBookingSpecificRefundPending = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="text-[12px] text-[#696A6A]">{item.userId?.email}</p>
				</div>
			</div>
		),
	},
	{
		key: "phoneNo",
		label: "Mobile No",
		render: (item) => item.phoneNo,
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "bookingDate",
		label: "Booking Date",
		render: (item) => formatDateCustomFormate(item.bookingDate, 'DD/MM/YYYY'),
	},
	{
		key: "cancelDate",
		label: "Cancel Date",
		render: (item) => formatDateCustomFormate(item.specificCancelMoveToRefundDate, 'DD/MM/YYYY'),
	},
	{
		key: "payment",
		label: "Refund Amount",
		render: (item) => formatToINR(item.specificCancelRefundedAmount),
	},
	{
		key: "status",
		label: "Status",
		render: (item) => <StatusColumn status="Refund Pending" />,
	}
];

const columnsBookingRefunded = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="text-[12px] text-[#696A6A]">{item.userId?.email}</p>
				</div>
			</div>
		),
	},
	{
		key: "phoneNo",
		label: "Mobile No",
		render: (item) => item.phoneNo,
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "bookingDate",
		label: "Booking Date",
		render: (item) => formatDateCustomFormate(item.bookingDate, 'DD/MM/YYYY'),
	},
	{
		key: "cancelDate",
		label: "Cancel Date",
		render: (item) => formatDateCustomFormate(item.cancelDate, 'DD/MM/YYYY'),
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.finalAmount),
	},
	{
		key: "refundedDate",
		label: "Refunded Date",
		render: (item) => formatDateCustomFormate(item.refundDate, 'DD/MM/YYYY'),
	},
	{
		key: "refundBy",
		label: "Refund By",
		render: (item) => item.refundBy?.firstName + " " + item.refundBy?.lastName,
	},
	{
		key: "status",
		label: "Status",
		render: (item) => <StatusColumn status="Refunded" />,
	}
];

const columnsBookingSpecificRefunded = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="text-[12px] text-[#696A6A]">{item.userId?.email}</p>
				</div>
			</div>
		),
	},
	{
		key: "phoneNo",
		label: "Mobile No",
		render: (item) => item.phoneNo,
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "bookingDate",
		label: "Booking Date",
		render: (item) => formatDateCustomFormate(item.bookingDate, 'DD/MM/YYYY'),
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.specificCancelRefundedAmount),
	},
	{
		key: "refundDate",
		label: "Refund Date",
		render: (item) => formatDateCustomFormate(item.specificCancelRefundDate, 'DD/MM/YYYY'),
	},
	{
		key: "refundBy",
		label: "Refund By",
		render: (item) => item.specificCancelRefundBy?.firstName + " " + item.specificCancelRefundBy?.lastName,
	},
	{
		key: "status",
		label: "Status",
		render: (item) => <StatusColumn status="Refunded" />,
	}
];

const columnsTeam = (handleToggleChange) => [
	{
		key: "name",
		label: "Name",
		render: (item) => (
			<div className="flex gap-2 items-center min-w-[160px]">
				{item.profile ? (
					<div className="w-10 h-10 min-w-[40px] shrink-0 rounded-full overflow-hidden flex items-center justify-center">
						<img src={config.base.awsUrl + item.profile} className="w-10 h-10 min-w-[40px] rounded-full object-cover shrink-0" alt="img" />
					</div>
				) : (<div className="w-10 h-10 min-w-[40px] shrink-0 flex items-center justify-center bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full font-medium text-sm">
					{item.nameInitials}
				</div>)}
				<div className="whitespace-nowrap">
					<p>{item.firstName}</p>
				</div>
			</div>
		),
	},
	{
		key: "employeeId",
		label: "Employee Id",
		render: (item) => item.employeeId,
	},
	{
		key: "username",
		label: "User Name",
		render: (item) => item.username,
	},
	{
		key: "email",
		label: "Email",
		render: (item) => item.email,
	},
	{
		key: "phoneNo",
		label: "Login Number",
		render: (item) => item.phoneNo,
	},
	{
		key: "contactNumber",
		label: "Contact Number",
		render: (item) => item.contactNumber || item.contactNo || "-",
	},
	{
		key: "fatherNumber",
		label: "Father Contact Number",
		render: (item) => item.fatherNumber || item.fatherPhoneNo || "-",
	},
	{
		key: "loginAccess",
		label: "Login Access",
		render: (item) => (
			<label className="cursor-pointer">
				<input
					type="checkbox"
					value="1"
					className="sr-only peer"
					onChange={(e) => handleToggleChange(e, item)}
					checked={item.loginAccess}
				/>
				<div className="relative w-11 h-6 bg-red-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-green-300 dark:peer-focus:ring-green-800 dark:bg-red-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-red-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-red-600 peer-checked:bg-green-600"></div>
				<span className="ms-3 text-sm font-medium text-red-900 dark:text-red-300"></span>
			</label>
		),
	},
];

const columnsBankAccount = [
	{
		key: "accountName",
		label: "Account Name",
		render: (item) => item.accountName,
	},
	{
		key: "mobileNumber",
		label: "Mobile Number",
		render: (item) => item.mobileNumber,
	},
	{
		key: "bankName",
		label: "Bank Name",
		render: (item) => item?.bankName,
	},
	{
		key: "accountDetail",
		label: "Account Detail",
		render: (item) => (
			<div className="">
				<p>Account Number: {item.accountNumber}</p>
				<p>IFSC Code: {item.ifscCode}</p>
			</div>
		),
	},
	{
		key: "upiId",
		label: "UPI ID",
		render: (item) => item.upiId,
	},
	{
		key: "cardDetail",
		label: "Card Detail",
		render: (item) => (
			<div className="">
				<p>Card Number: {item.cardNumber}</p>
				<p>Expirer On: {item.expirerOn}</p>
				<p>CSV Number: {item.csvNumber}</p>
				<p>Name On Card: {item.nameOnCard}</p>
			</div>
		),
	},
	{
		key: "currentBalance",
		label: "Current Balance",
		render: (item) => formatToINR(item.currentBalance),
	},
];

const columnsDebitCategory = [
	{
		key: "categoryName",
		label: "Debit Category Name",
		render: (item) => item.categoryName,
	},
];

const columnsCreditCategory = [
	{
		key: "categoryName",
		label: "Credit Category Name",
		render: (item) => item.categoryName,
	},
];

const columnsCreditCard = [
	{
		key: "accountName",
		label: "Account Name",
		render: (item) => item.accountName,
	},
	{
		key: "mobileNumber",
		label: "Mobile Number",
		render: (item) => item.mobileNumber,
	},
	{
		key: "bankName",
		label: "Bank Name",
		render: (item) => item?.bankName,
	},
	{
		key: "cardDetail",
		label: "Card Detail",
		render: (item) => (
			<div className="">
				<p>Card Number: {item.cardNumber}</p>
				<p>Expirer On: {item.expirerOn}</p>
				<p>CSV Number: {item.csvNumber}</p>
				<p>Name On Card: {item.nameOnCard}</p>
			</div>
		),
	},
	{
		key: "currentBalance",
		label: "Current Balance",
		render: (item) => formatToINR(item.currentBalance),
	},
];

const columnsCrDrNote = [
	{
		key: "Date",
		label: "Date",
		render: (item) => formatDateCustomFormate(item.transactionDate, 'DD-MM-YYYY'),
	},
	{
		key: "amount",
		label: "Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.amount)}
			</div>
		)
	},
	{
		key: "AccountName",
		label: "Bank",
		render: (item) => item.accountId?.bankName,
	},
	{
		key: "ledger",
		label: "Ledger",
		render: (item) => item.ledgerId?.name,
	},
	{
		key: "title",
		label: "Descriptions",
		render: (item) => item.title,
	},
];

const columnsHomeBanner = [
	{
		key: "image",
		label: "Image",
		render: (item) => (
			<div className="w-40 h-20 overflow-hidden">
				<img
					src={config.base.awsUrl + item.path}
					alt="banner"
					className="w-full h-full object-cover"
				/>
			</div>
		),
	},
	{
		key: "title",
		label: "Title",
		render: (item) => item.title,
	},
	{
		key: "url",
		label: "URL",
		render: (item) => item.url,
	},
];

const columnsHomePlace = [
	{
		key: "image",
		label: "Image",
		render: (item) => (
			<div className="w-40 h-20 overflow-hidden">
				<img
					src={config.base.awsUrl + item.placeHomePageImage}
					alt="banner"
					className="h-full"
				/>
			</div>
		),
	},
	{
		key: "title",
		label: "Title",
		render: (item) => item.placeId?.name,
	},
];

const columnsPhoneNumber = [
	{
		key: "phoneNumber",
		label: "Phone Number",
		render: (item) => item.phoneNumber,
	}
];

const columnsBankAccess = [
	{
		key: "name",
		label: "Employee Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				{item.staffDetails?.profile ? (
					<div className="rounded-full">
						<img src={config.base.awsUrl + item.staffDetails?.profile} className="w-10 h-10 rounded-full" alt="img" />
					</div>
				) : (<div className="px-3 py-3 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.staffDetails?.nameInitials}
				</div>)}
				<div>
					<p>{item.staffDetails?.firstName}</p>
					<p className="text-[12px] text-[#696A6A]">{item.staffDetails?.employeeId}</p>
				</div>
			</div>
		),
	},
	{
		key: "date",
		label: "Date",
		render: (item) => formatDateCustomFormate(item.assignDate, 'DD/MM/YYYY'),
	},
	{
		key: "time",
		label: "Time",
		render: (item) => formatDateCustomFormate(item.assignDate, 'hh:mm A'),
	},
	{
		key: "bank",
		label: "Bank",
		render: (item) => item.accountDetails.bankName,
	},
	{
		key: "openingBalance",
		label: "Opening Balance",
		render: (item) => formatToINR(item.openingBalance),
	},
	{
		key: "actualOpeningBalance",
		label: "Actual Opening Balance",
		render: (item) => formatToINR(item.actualOpeningBalance),
	},
	{
		key: "availableBalance",
		label: "Available Balance",
		render: (item) => formatToINR(item.accountDetails.currentBalance),
	},
	{
		key: "accountType",
		label: "Account Type",
		render: (item) => (item.isPrimary) ? "Primary" : "Secondary",
	},
];

const columnsBankTransfer = [
	{
		key: "Date",
		label: "Date",
		render: (item) => formatDateCustomFormate(item.transactionDate, 'DD-MM-YYYY'),
	},
	{
		key: "fromBank",
		label: "From Bank",
		render: (item) => item.accountId?.bankName,
	},
	{
		key: "toBank",
		label: "To Bank",
		render: (item) => item.ledgerId?.name,
	},
	{
		key: "amount",
		label: "Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.amount)}
			</div>
		)
	},
	{
		key: "title",
		label: "Descriptions",
		render: (item) => item.title,
	},
];

const columnsNumberAccess = [
	{
		key: "name",
		label: "Employee Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				{item.staffDetails?.profile ? (
					<div className="rounded-full">
						<img src={config.base.awsUrl + item.staffDetails?.profile} className="w-10 h-10 rounded-full" alt="img" />
					</div>
				) : (<div className="px-3 py-3 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.staffDetails?.nameInitials}
				</div>)}
				<div>
					<p>{item.staffDetails?.firstName}</p>
					<p className="text-[12px] text-[#696A6A]">{item.staffDetails?.employeeId}</p>
				</div>
			</div>
		),
	},
	{
		key: "date",
		label: "Date",
		render: (item) => formatDateCustomFormate(item.assignDate, 'DD/MM/YYYY'),
	},
	{
		key: "time",
		label: "Time",
		render: (item) => formatDateCustomFormate(item.assignDate, 'hh:mm A'),
	},
	{
		key: "number",
		label: "Number",
		render: (item) => item.numberDetails?.phoneNumber,
	},
];

const columnsBookingUpcoming = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="text-[12px] text-[#696A6A]">{item.userId?.email}</p>
				</div>
			</div>
		),
	},
	{
		key: "phoneNo",
		label: "Mobile No",
		render: (item) => item.phoneNo,
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "visitingDate",
		label: "Visiting Date",
		render: (item) => moment(item.visitingDate).format("DD-MM-YYYY"),
	},
	{
		key: "bookingDate",
		label: "Booking Date",
		render: (item) => formatDateCustomFormate(item.bookingDate, 'DD/MM/YYYY'),
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.finalAmount),
	},
	{
		key: "status",
		label: "Status",
		render: (item) => <StatusColumn status={item.bookingStatus} />,
	},
	{
		key: "paymentStatus",
		label: "Payment Status",
		render: (item) => <StatusColumn status={item.paymentStatus} />,
	}
];

const columnsBookingUpcomingWithCheckbox = (handleCheckboxChange) => [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<input type="checkbox" value={item._id} className="h-5 peer" onChange={(e) => handleCheckboxChange(e, item._id)} />
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="flex gap-1 items-center text-[12px] text-[#696A6A]"><CiStopwatch className="text-sm" /> {formatDateCustomFormate(item.bookingDate, 'DD-MM-YYYY ddd | hh:mm A')}</p>
				</div>
			</div>
		),
	},
	{
		key: "phoneNo",
		label: "Mobile No",
		render: (item) => item.phoneNo,
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "visitingDate",
		label: "Visiting Date",
		render: (item) => moment(item.visitingDate).format("DD-MM-YYYY"),
	},
	{
		key: "bookingDate",
		label: "Booking Date",
		render: (item) => formatDateCustomFormate(item.bookingDate, 'DD/MM/YYYY'),
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.finalAmount),
	},
	{
		key: "status",
		label: "Status",
		render: (item) => <StatusColumn status={item.bookingStatus} />,
	},
	{
		key: "paymentStatus",
		label: "Payment Status",
		render: (item) => <StatusColumn status={item.paymentStatus} />,
	}
];

const columnsQuotation = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="px-3 py-2 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFirstName + " " + item.customerLastName}</p>
					<p className="text-[12px] text-[#696A6A]">{formatDateCustomFormate(item.quotationDate, 'DD/MM/YYYY ddd | hh:mm A')}</p>
				</div>
			</div>
		),
	},
	{
		key: "ContactDetails",
		label: "ContactDetails",
		render: (item) => (<div>
			<p>{item.email}</p>
			<p className="text-[12px] text-[#696A6A]">{item.phoneNo}</p>
		</div>
		),
	},
	{
		key: "quotationId",
		label: "Quotation Id",
		render: (item) => item.quotationId,
	},
	{
		key: "visitingDate",
		label: "Visiting Date",
		render: (item) => (item.visitingDate) ? moment(item.visitingDate).format("DD-MM-YYYY") : '',
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.finalAmount),
	},
	{
		key: "status",
		label: "Status",
		render: (item) => <StatusColumn status={item.quotationStatus} />,
	},
	{
		key: "staffWorking",
		label: "Staff Working",
		render: (item) => item.quotationCreatedBy.firstName,
	},
];

const columnVisitor = [
	{
		key: "name",
		label: "Visitor name",
		render: (item) => item.firstName + ' ' + item.lastName,
	},
	{
		key: "gender",
		label: "Gender",
		render: (item) => item.gender,
	},
	{
		key: "age",
		label: "Age",
		render: (item) => item.age,
	},
	{
		key: "state",
		label: "State",
		render: (item) => item.stateName,
	},
	{
		key: "country",
		label: "Country",
		render: (item) => item.countryName,
	},
];

const columnsBookingSpecificCancel = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="text-[12px] text-[#696A6A]">{item.userId?.email}</p>
				</div>
			</div>
		),
	},
	{
		key: "phoneNo",
		label: "Mobile No",
		render: (item) => item.phoneNo,
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "bookingDate",
		label: "Booking Date",
		render: (item) => formatDateCustomFormate(item.bookingDate, 'DD/MM/YYYY'),
	},
	{
		key: "cancelDate",
		label: "Cancel Date",
		render: (item) => formatDateCustomFormate(item.specificCancelDate, 'DD/MM/YYYY'),
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.finalAmount - item.specificCancelRefundedAmount),
	},
	{
		key: "RefundableAmount",
		label: "Refundable Amount",
		render: (item) => formatToINR(item.specificCancelRefundedAmount),
	},
	{
		key: "cancelBy",
		label: "Cancel By",
		render: (item) => (item.specificCancelBy) ? (item?.specificCancelBy?.firstName + " " + item?.specificCancelBy?.lastName) : "",
	},
	{
		key: "status",
		label: "Status",
		render: (item) => <StatusColumn status={item.specificCancelStatus} />,
	}
];

const columnsTeamBankReport = [
	{
		key: "name",
		label: "Employee Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				{item.staffId?.profile ? (
					<div className="rounded-full">
						<img src={config.base.awsUrl + item.staffId?.profile} className="w-10 h-10 rounded-full" alt="img" />
					</div>
				) : (<div className="px-3 py-3 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.staffId?.nameInitials}
				</div>)}
				<div>
					<p>{item.staffId?.firstName}</p>
					<p className="text-[12px] text-[#696A6A]">{item.staffId?.employeeId}</p>
				</div>
			</div>
		),
	},
	{
		key: "bank",
		label: "Bank",
		render: (item) => item.accountId.bankName,
	},
	{
		key: "openingBalance",
		label: "Opening Balance",
		render: (item) => formatToINR(item.openingBalance),
	},
	{
		key: "closingBalance",
		label: "Closing Balance",
		render: (item) => formatToINR(item.closingBalance),
	},
];

const columnsSalesBooking = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="px-3 py-3 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item?.nameInitials}
				</div>
				<div>
					<p>{item.userId?.firstName + ' ' + item.userId?.lastName}</p>
					<p className="text-[12px] text-[#696A6A]">{item.userId?.email}</p>
				</div>
			</div>
		),
	},
	{
		key: "visitingDate",
		label: "Visiting Date",
		render: (item) => moment(item.visitingDate).format("DD-MM-YYYY"),
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "purchase",
		label: "Purchase Amount",
		render: (item) => formatToINR(item.purchaseAmount),
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.finalAmount),
	},
	{
		key: "status",
		label: "Status",
		render: (item) => item.bookingStatus === 'pending' && item.cancelBy ? <StatusColumn status="Cancel By User" /> : <StatusColumn status={item.bookingStatus} />,
	},
];

const columnsEnquiry = [
	{
		key: "name",
		label: "Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item?.nameInitials || (item?.firstName ? item.firstName.charAt(0) : "E")}
				</div>
				<div>
					<p>{item?.firstName ? `${item.firstName} ${item.lastName || ""}`.trim() : (item?.name || "-")}</p>
				</div>
			</div>
		),
	},
	{
		key: "Email",
		label: "email",
		render: (item) => item?.email || "-",
	},
	{
		key: "Mobile No",
		label: "Phone No",
		render: (item) => item?.phoneNo || "-",
	},
	{
		key: "Message",
		label: "message",
		render: (item) => {
			const message = item?.message || "";
			if (!message) return "-";
			const isLong = message.length > 35;
			return (
				<span
					className="block max-w-[260px] truncate cursor-pointer"
					title={message}
				>
					{isLong ? `${message.substring(0, 35)}..` : message}
				</span>
			);
		},
	},
	{
		key: "staffNote",
		label: "staff Note",
		render: (item) => {
			const note = item?.staffNote || "";
			if (!note) return "-";
			const isLong = note.length > 35;
			return (
				<span
					className="block max-w-[260px] truncate cursor-pointer"
					title={note}
				>
					{isLong ? `${note.substring(0, 35)}..` : note}
				</span>
			);
		},
	},
];

const columnsPlaceKey = [
	{
		key: "placeName",
		label: "Place",
		render: (item) => item.name,
	},
	{
		key: "placeKey",
		label: "Key",
		render: (item) => item.key,
	}
];

const columnsFaqs = [
	{
		key: "question",
		label: "Question",
		render: (item) => item.question,
	},
	{
		key: "answer",
		label: "Answer",
		render: (item) => {
			return <div dangerouslySetInnerHTML={{ __html: item.answer }} />;
		},
	}
];

const columnsAvailableTicket = (handleInputChange, handleActionClick, mackAllSlotOpen) => [
	{
		key: "name",
		label: "Place Name",
		render: (item) => item.name,
	},
	{
		key: "slot",
		label: "Slot",
		render: (item) => (
			<CustomInputField
				className=""
				key={1}
				error=""
				field="attractionSlotId"
				type="select"
				placeholder="Select Slot"
				label=""
				value={item.attractionSlotId}
				options={[
					{ value: "0", label: "Select Slot" },
					...(item.slots || []).map((slot) => ({
						value: slot._id,
						label: slot.startTime.slice(0, 5) + " - " + slot.endTime.slice(0, 5),
						startTime: slot.startTime
					}))
						.sort((a, b) => a.startTime.localeCompare(b.startTime))
						.map((slot) => ({
							value: slot.value,
							label: slot.label,
						})
						)
				]}
				onChange={(e) => handleInputChange(item._id, item.slotType, e.target.value, item)}
			/>
		),
	},
	{
		key: "ticketAvailable",
		label: "Ticket Available",
		render: (item) => (
			item.attractionSlotId ? (
				item.availableTicket > 0 ? (
					<label className="text-[#40A648] font-bold text-sm">{item.availableTicket}</label>
				) : (
					<label className="text-[#DB0011] font-bold text-sm">SOLD</label>
				)
			) : (
				<span></span>
			)
		),
	},
	...(mackAllSlotOpen
		? [
			{
				key: "action",
				label: "Action",
				render: (item) => (
					<div
						className="cursor-pointer w-9 h-10"
						onClick={() => handleActionClick(item)}
					>
						<img src={actionIcon} className="w-8 h-8" alt="img" />
					</div>
				),
			},
		]
		: []),
];

const eRikshawBookingHistory = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="flex gap-1 items-center text-[12px] text-[#696A6A]"><CiStopwatch className="text-sm" /> {formatDateCustomFormate(item.bookingDate, 'DD-MM-YYYY ddd | hh:mm A')}</p>
				</div>
			</div>
		),
	},
	{
		key: "visitingDate",
		label: "Visiting Date",
		render: (item) => formatDateCustomFormate(item.visitingDate, 'DD-MM-YYYY'),
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "confirmDate",
		label: "Confirm Date",
		render: (item) => item.eRikshawConfirmDate ? formatDateCustomFormate(item.eRikshawConfirmDate, 'DD-MM-YYYY') : '',
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.eRikshawPendingAmount),
	},
	{
		key: "status",
		label: "Booking Status",
		render: (item) => item.eRikshawBookingStatus === 'confirmFromSOU' ? <StatusColumn status="confirm from jyoti" /> : <StatusColumn status={item.eRikshawBookingStatus} />,
	},
	{
		key: "ConfirmBy",
		label: "Confirm By",
		render: (item) => (item.eRikshawConfirmBy) ? (item.eRikshawConfirmBy.firstName + " " + item.eRikshawConfirmBy.lastName) : item.confirmBy ? (item.confirmBy.firstName + " " + item.confirmBy.lastName) : '',
	},
];

const columnsTestimonial = [
	{
		key: "name",
		label: "Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				{
					item.image && (
						<div className="rounded-lg w-20 h-20 overflow-hidden">
							<img
								src={config.base.awsUrl + item.image}
								alt="PlaceImage"
								className="w-full h-full object-cover"
							/>
						</div>
					)
				}
				<div>
					<p>{item.name}</p>
				</div>
			</div>
		),
	},
	{
		key: "subTitle",
		label: "Sub Title",
		render: (item) => item.subTitle,
	},
	{
		key: "message",
		label: "Message",
		render: (item) => item.message,
	}
];

const columnSalesReport = [
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "name",
		label: "Client Name",
		render: (item) => item.customerFullName,
	},
	{
		key: "phoneNumber",
		label: "Client Phone",
		render: (item) => item.phoneNo,
	},
	{
		key: "Date",
		label: "Payment Date",
		render: (item) => (item.bookingMethod === 'offline') ? formatDateCustomFormate(item.bookingDate, 'DD-MM-YYYY') : formatDateCustomFormate(item?.paymentDetail?.paymentDate, 'DD-MM-YYYY'),
	},
	{
		key: "ticketAmount",
		label: "Ticket Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.totalAmount)}
			</div>
		)
	},
	{
		key: "hotelAmount",
		label: "Hotel Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.hotel?.finalRoomPrice || 0)}
			</div>
		)
	},
	{
		key: "commissionAmount",
		label: "Commission Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR((item.serviceCharge || 0) + (item.hotel?.totalServiceCharge || 0))}
			</div>
		)
	},
	{
		key: "amount",
		label: "Total Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.orderFinalAmount)}
			</div>
		)
	},
	{
		key: "paymentMethod",
		label: "Payment Method",
		render: (item) => (item.bookingMethod === 'offline') ? "Offline" : item.paymentDetail?.paymentMethod,
	},
	{
		key: "paymentTransactionId",
		label: "Payment Transaction Id",
		render: (item) => item.paymentDetail?.paymentId,
	},
];

const columnGstReport = (commissionRate = 5) => [
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "name",
		label: "Client Name",
		render: (item) => item.customerFullName,
	},
	{
		key: "Date",
		label: "Payment Date",
		render: (item) => (item.bookingMethod === 'offline') ? formatDateCustomFormate(item.bookingDate, 'DD-MM-YYYY') : formatDateCustomFormate(item?.paymentDetail?.paymentDate, 'DD-MM-YYYY'),
	},
	{
		key: "paymentMethod",
		label: "Payment Method",
		render: (item) => (item.bookingMethod === 'offline') ? "Offline" : item.paymentDetail?.paymentMethod,
	},
	{
		key: "ticketAmount",
		label: "Ticket Amount",
		render: (item) => {
			const ticketAmt = (item.totalAmount || 0) + (item.serviceCharge || 0);
			return (
				<div className="text-primary font-medium">
					{formatToINR(ticketAmt)}
				</div>
			);
		}
	},
	{
		key: "hotelAmount",
		label: "Hotel Amount",
		render: (item) => {
			const hotelAmt = item.hotel?.totalFinalPrice || item.hotel?.finalRoomPrice || 0;
			return (
				<div className="text-primary font-medium">
					{formatToINR(hotelAmt)}
				</div>
			);
		}
	},
	{
		key: "netValue",
		label: "NET Value",
		render: (item) => {
			const ticketAmt = (item.totalAmount || 0) + (item.serviceCharge || 0);
			const hotelAmt = item.hotel?.totalFinalPrice || item.hotel?.finalRoomPrice || 0;
			const netVal = ticketAmt + hotelAmt;
			return (
				<div className="text-[#D97706] font-semibold">
					{formatToINR(netVal)}
				</div>
			);
		}
	},
	{
		key: "ticket",
		label: "Ticket",
		render: (item) => {
			const ticketAmt = (item.totalAmount || 0) + (item.serviceCharge || 0);
			const hotelAmt = item.hotel?.totalFinalPrice || item.hotel?.finalRoomPrice || 0;
			const netVal = ticketAmt + hotelAmt;
			const rate = Number(commissionRate) || 0;
			const comm = (netVal * rate) / 100;
			const purchaseAmt = netVal - comm;
			return (
				<div className="text-[#0D7EB8] font-semibold">
					{formatToINR(purchaseAmt)}
				</div>
			);
		}
	},
	{
		key: "commissionAmount",
		label: "Commission Amount",
		render: (item) => {
			const ticketAmt = (item.totalAmount || 0) + (item.serviceCharge || 0);
			const hotelAmt = item.hotel?.totalFinalPrice || item.hotel?.finalRoomPrice || 0;
			const netVal = ticketAmt + hotelAmt;
			const rate = Number(commissionRate) || 0;
			const comm = (netVal * rate) / 100;
			return (
				<div className="text-primary font-semibold">
					{formatToINR(comm)}
				</div>
			);
		}
	},
	{
		key: "taxableValue",
		label: "Taxable Value",
		render: (item) => {
			const ticketAmt = (item.totalAmount || 0) + (item.serviceCharge || 0);
			const hotelAmt = item.hotel?.totalFinalPrice || item.hotel?.finalRoomPrice || 0;
			const netVal = ticketAmt + hotelAmt;
			const rate = Number(commissionRate) || 0;
			const comm = (netVal * rate) / 100;
			const taxable = comm / 1.18;
			return (
				<div className="text-[#0D7EB8] font-semibold">
					{formatToINR(taxable)}
				</div>
			);
		}
	},
	{
		key: "cgst",
		label: "CGST",
		render: (item) => {
			const ticketAmt = (item.totalAmount || 0) + (item.serviceCharge || 0);
			const hotelAmt = item.hotel?.totalFinalPrice || item.hotel?.finalRoomPrice || 0;
			const netVal = ticketAmt + hotelAmt;
			const rate = Number(commissionRate) || 0;
			const comm = (netVal * rate) / 100;
			const taxable = comm / 1.18;
			const cgst = taxable * 0.09;
			return (
				<div className="text-[#40A648] font-semibold">
					{formatToINR(cgst)}
				</div>
			);
		}
	},
	{
		key: "sgst",
		label: "SGST",
		render: (item) => {
			const ticketAmt = (item.totalAmount || 0) + (item.serviceCharge || 0);
			const hotelAmt = item.hotel?.totalFinalPrice || item.hotel?.finalRoomPrice || 0;
			const netVal = ticketAmt + hotelAmt;
			const rate = Number(commissionRate) || 0;
			const comm = (netVal * rate) / 100;
			const taxable = comm / 1.18;
			const sgst = taxable * 0.09;
			return (
				<div className="text-[#40A648] font-semibold">
					{formatToINR(sgst)}
				</div>
			);
		}
	},
	{
		key: "billAmount",
		label: "Bill Amount",
		render: (item) => {
			const ticketAmt = (item.totalAmount || 0) + (item.serviceCharge || 0);
			const hotelAmt = item.hotel?.totalFinalPrice || item.hotel?.finalRoomPrice || 0;
			const netVal = ticketAmt + hotelAmt;
			const rate = Number(commissionRate) || 0;
			const comm = (netVal * rate) / 100;
			return (
				<div className="text-[#DB0011] font-bold">
					{formatToINR(comm)}
				</div>
			);
		}
	},
];

const columnPurchaseReport = [
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "name",
		label: "Client Name",
		render: (item) => item.customerFullName,
	},
	{
		key: "phoneNumber",
		label: "Client Phone",
		render: (item) => item.phoneNo,
	},
	{
		key: "Date",
		label: "Payment Date",
		render: (item) => (item.bookingMethod === 'offline') ? formatDateCustomFormate(item.bookingDate, 'DD-MM-YYYY') : formatDateCustomFormate(item?.paymentDetail?.paymentDate, 'DD-MM-YYYY'),
	},
	{
		key: "confirmDate",
		label: "Purchase Date",
		render: (item) => formatDateCustomFormate(item.confirmDate, 'DD-MM-YYYY'),
	},
	{
		key: "purchaseAmount",
		label: "Purchase Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.purchaseAmount)}
			</div>
		)
	},
	{
		key: "souPurchaseAmount",
		label: "SOU Ticket Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.purchaseAmount)}
			</div>
		)
	},
	{
		key: "hotelAmount",
		label: "Hotel Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.hotel?.finalRoomPrice || 0)}
			</div>
		)
	},
	{
		key: "eRickshawAmount",
		label: "E-Rickshaw Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.eRikshawAmount || item.eRikshawConfirmAmount)}
			</div>
		)
	},
	{
		key: "amount",
		label: "Sales Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.orderFinalAmount)}
			</div>
		)
	},
	// {
	// 	key: "paymentMethod",
	// 	label: "Payment Method",
	// 	render: (item) => (item.bookingMethod === 'offline') ? "Offline" : item.paymentDetail?.paymentMethod,
	// },
	// {
	// 	key: "paymentTransactionId",
	// 	label: "Payment Transaction Id",
	// 	render: (item) => item.paymentDetail?.paymentId,
	// },
	// {
	// 	key: "paymentStatus",
	// 	label: "Payment Status",
	// 	render: (item) => item.paymentStatus,
	// }
];

const columnCommissionReport = [
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "name",
		label: "Client Name",
		render: (item) => item.customerFullName,
	},
	{
		key: "phoneNumber",
		label: "Client Phone",
		render: (item) => item.phoneNo,
	},
	{
		key: "Date",
		label: "Payment Date",
		render: (item) => (item.bookingMethod === 'offline') ? formatDateCustomFormate(item.bookingDate, 'DD-MM-YYYY') : formatDateCustomFormate(item?.paymentDetail?.paymentDate, 'DD-MM-YYYY'),
	},
	{
		key: "ticketAmount",
		label: "Ticket Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.totalAmount)}
			</div>
		)
	},
	{
		key: "hotelAmount",
		label: "Hotel Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.hotel?.finalRoomPrice || 0)}
			</div>
		)
	},
	{
		key: "commissionAmount",
		label: "Commission Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR((item.serviceCharge || 0) + (item.hotel?.totalServiceCharge || 0))}
			</div>
		)
	},
	{
		key: "amount",
		label: "Total Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.orderFinalAmount)}
			</div>
		)
	},
	{
		key: "paymentMethod",
		label: "Payment Method",
		render: (item) => (item.bookingMethod === 'offline') ? "Offline" : item.paymentDetail?.paymentMethod,
	},
	{
		key: "paymentTransactionId",
		label: "Payment Transaction Id",
		render: (item) => item.paymentDetail?.paymentId,
	},
	{
		key: "paymentStatus",
		label: "Payment Status",
		render: (item) => item.paymentStatus,
	}
];

const columnCancelReport = [
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "name",
		label: "Client Name",
		render: (item) => item.customerFullName,
	},
	{
		key: "phoneNumber",
		label: "Client Phone",
		render: (item) => item.phoneNo,
	},
	{
		key: "Date",
		label: "Payment Date",
		render: (item) => (item.bookingMethod === 'offline') ? formatDateCustomFormate(item.bookingDate, 'DD-MM-YYYY') : formatDateCustomFormate(item?.paymentDetail?.paymentDate, 'DD-MM-YYYY'),
	},
	{
		key: "amount",
		label: "Ticket Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.totalAmount)}
			</div>
		)
	},
	{
		key: "cancelDate",
		label: "Cancel Date",
		render: (item) => (
			<div className="text-primary">
				{formatDateCustomFormate(item.cancelDate, 'DD-MM-YYYY')}
			</div>
		)
	},
	{
		key: "Refund Amount",
		label: "Refund Amount",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.refundableAmount)}
			</div>
		)
	},
	{
		key: "specificCancel",
		label: "Specific Cancel",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.specificCancelRefundedAmount)}
			</div>
		)
	},
	{
		key: "souTicketCancel",
		label: "SOU Ticket Cancel",
		render: (item) => (
			<div className="text-primary">
				{formatToINR(item.refundableAmount)}
			</div>
		)
	},
	{
		key: "paymentMethod",
		label: "Payment Method",
		render: (item) => (item.bookingMethod === 'offline') ? "Offline" : item.paymentDetail?.paymentMethod,
	},
	{
		key: "paymentTransactionId",
		label: "Payment Transaction Id",
		render: (item) => item.paymentDetail?.paymentId,
	}
];

const columnAttractionReport = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="flex gap-1 items-center text-[12px] text-[#696A6A]"><CiStopwatch className="text-sm" /> {formatDateCustomFormate(item.bookingDate, 'DD-MM-YYYY ddd | hh:mm A')}</p>
				</div>
			</div>
		),
	},
	{
		key: "phoneNumber",
		label: "Client Phone",
		render: (item) => item.phoneNo,
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "visitingDate",
		label: "Visiting Date",
		render: (item) => moment(item.visitingDate).format("DD-MM-YYYY"),
	},
	{
		key: "payment",
		label: "Payment",
		render: (item) => formatToINR(item.finalAmount),
	},
	{
		key: "status",
		label: "Status",
		render: (item) => item.bookingStatus === 'pending' && item.cancelBy ? <StatusColumn status="Cancel By User" /> : item.bookingStatus === 'cancelConfirm' ? <StatusColumn status="SOU Cancel Confirm" /> : item.bookingStatus === 'refundPending' ? <StatusColumn status="Refund Pending" /> : item.bookingStatus === 'refunded' ? <StatusColumn status="Refunded" /> : <StatusColumn status={item.bookingStatus} />,
	},
];

const columnBookingReviewList = (handleCheckboxChange, selectedIds = []) => [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<input type="checkbox" value={item._id} className="h-5 peer" checked={selectedIds.includes(item._id)} onChange={(e) => handleCheckboxChange(e, item._id)} />
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="flex gap-1 items-center text-[12px] text-[#696A6A]"><CiStopwatch className="text-sm" /> {formatDateCustomFormate(item.bookingDate, 'DD-MM-YYYY ddd | hh:mm A')}</p>
				</div>
			</div>
		),
	},
	{
		key: "phoneNumber",
		label: "Client Phone",
		render: (item) => item.phoneNo,
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "visitingDate",
		label: "Visiting Date",
		render: (item) => moment(item.visitingDate).format("DD-MM-YYYY"),
	},
	{
		key: "status",
		label: "Status",
		render: (item) => item.bookingStatus === 'pending' && item.cancelBy ? <StatusColumn status="Cancel By User" /> : item.bookingStatus === 'cancelConfirm' ? <StatusColumn status="SOU Cancel Confirm" /> : item.bookingStatus === 'refundPending' ? <StatusColumn status="Refund Pending" /> : item.bookingStatus === 'refunded' ? <StatusColumn status="Refunded" /> : <StatusColumn status={item.bookingStatus} />,
	},
];

const columnsPendingSettlement = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
					<p className="flex gap-1 items-center text-[12px] text-[#696A6A]"><CiStopwatch className="text-sm" /> {formatDateCustomFormate(item.visitingDate, 'DD-MM-YYYY ddd')}</p>
				</div>
			</div>
		),
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "bookingDate",
		label: "Booking Date",
		render: (item) => formatDateCustomFormate(item?.bookingDate, 'DD-MM-YYYY hh:mm A'),
	},
	{
		key: "amount",
		label: "Amount",
		render: (item) => formatToINR(item.finalAmount),
	},
	{
		key: "paymentMethod",
		label: "Payment Method",
		render: (item) => item.paymentDetail?.paymentMethod,
	},
	{
		key: "paymentTransactionId",
		label: "Payment Transaction Id",
		render: (item) => item.paymentDetail?.paymentId,
	}
];

const columnsProgressSettlement = [
	{
		key: "name",
		label: "Customer Name",
		render: (item) => (
			<div className="flex gap-2 items-center">
				<div className="flex justify-center items-center w-11 h-11 bg-[#40A648] text-[#40A648] bg-opacity-10 rounded-full">
					{item.nameInitials}
				</div>
				<div>
					<p>{item.customerFullName}</p>
				</div>
			</div>
		),
	},
	{
		key: "bookingId",
		label: "Booking ID",
		render: (item) => item.bookingId,
	},
	{
		key: "bookingDate",
		label: "Booking Date",
		render: (item) => formatDateCustomFormate(item?.bookingDate, 'DD-MM-YYYY hh:mm A'),
	},
	{
		key: "amount",
		label: "Amount",
		render: (item) => (item.finalAmount) ? formatToINR(item.finalAmount) : formatToINR(item.orderFinalAmount),
	},
	{
		key: "paymentMethod",
		label: "Payment Method",
		render: (item) => item.paymentDetail?.paymentMethod,
	},
	{
		key: "settleAmount",
		label: "Settle Amount",
		render: (item) => formatToINR(item.paymentDetail?.settleAmount),
	},
	{
		key: "paymentTransactionId",
		label: "Payment Transaction Id",
		render: (item) => item.paymentDetail?.paymentId,
	}
];

const columnsDailySettlementHistory = (handleView) => [
	{
		key: "settlementDate",
		label: "Settlement Date",
		render: (item) => moment(item.settlementDate).format("DD-MM-YYYY"),
	},
	{
		key: "totalSales",
		label: "Total Sales",
		render: (item) => formatToINR(item.totalSales),
	},
	{
		key: "totalSettlement",
		label: "Total Settlement",
		render: (item) => formatToINR(item.totalSettlement),
	},
	{
		key: "totalDifferenceAmount",
		label: "Total Difference Amount",
		render: (item) => formatToINR(item.totalDifferenceAmount),
	},
	{
		key: "action",
		label: "Action",
		render: (item) => (
			<div className="flex gap-3 items-center">
				<div onClick={() => handleView(item._id)} className="bg-[#0D7EB8] cursor-pointer w-8 h-8 rounded-xl flex justify-center items-center -mt-2">
					<FaRegEye className="text-white text-lg" />
				</div>
			</div>
		)
	}
];

const columnsAccountMainGroup = [
	{
		key: "name",
		label: "Group Name",
		render: (item) => <span className="font-medium text-gray-900">{item.name}</span>,
	},
	{
		key: "type",
		label: "Type",
		render: (item) => (
			<span className={"px-2.5 py-1 rounded-md text-xs font-semibold border " + (item.type === "Assets" || item.type === "DR" || item.type === "Income" ? "bg-green-50 text-green-700 border-green-200" : "bg-red-50 text-red-700 border-red-200")}>
				{item.type}
			</span>
		),
	},
	{
		key: "createdAt",
		label: "Created At",
		render: (item) => moment(item.createdAt).format("DD MMM YYYY, hh:mm A"),
	},
];

const columnsAccountSubGroup = [
	{
		key: "name",
		label: "Sub Group Name",
		render: (item) => <span className="font-medium text-gray-900">{item.name}</span>,
	},
	{
		key: "mainGroup",
		label: "Main Group",
		render: (item) => item.mainGroup?.name || "N/A",
	},
	{
		key: "type",
		label: "Type",
		render: (item) => (
			<span className={"px-2.5 py-1 rounded-md text-xs font-semibold border " + (item.mainGroup?.type === "Assets" || item.mainGroup?.type === "DR" || item.mainGroup?.type === "Income" ? "bg-green-50 text-green-700 border-green-200" : "bg-red-50 text-red-700 border-red-200")}>
				{item.mainGroup?.type || "N/A"}
			</span>
		),
	},
	{
		key: "createdAt",
		label: "Created At",
		render: (item) => moment(item.createdAt).format("DD MMM YYYY, hh:mm A"),
	},
];

const columnsAccountLedger = [
	{
		key: "name",
		label: "Ledger Name",
		render: (item) => <span className="font-medium text-gray-900">{item.name}</span>,
	},
	{
		key: "subGroup",
		label: "Group (Main/Sub)",
		render: (item) => item.subGroup?.name || item.mainGroup?.name || "N/A",
	},
	{
		key: "applicable",
		label: "Applicable",
		render: (item) => (
			<span className={"px-2.5 py-1 rounded-md text-xs font-semibold border " + (item.applicable === "None" ? "bg-gray-50 text-gray-700 border-gray-200" : "bg-blue-50 text-blue-700 border-blue-200")}>
				{item.applicable || "None"}
			</span>
		),
	},
	{
		key: "createdAt",
		label: "Created At",
		render: (item) => moment(item.createdAt).format("DD MMM YYYY, hh:mm A"),
	},
];

export {
	columnsPlace,
	columnsPlaceSettingOn,
	columnsPlaceSettingOff,
	columnsPackageCategory,
	columnsPackage,
	columnsBooking,
	columnsAllBooking,
	columnsTeam,
	columnsBookingCancel,
	columnsBookingCancelConfirm,
	columnsBookingRefundPending,
	columnsBookingSpecificRefundPending,
	columnsBookingRefunded,
	columnsBookingSpecificRefunded,
	columnsBankAccount,
	columnsCreditCard,
	columnsDebitCategory,
	columnsCreditCategory,
	columnsCrDrNote,
	columnsHomeBanner,
	columnsHomePlace,
	columnsPhoneNumber,
	columnsBankAccess,
	columnsBankTransfer,
	columnsNumberAccess,
	columnsBookingUpcoming,
	columnsQuotation,
	columnVisitor,
	columnsBookingSpecificCancel,
	columnsTeamBankReport,
	columnsSalesBooking,
	columnsConfirmBooking,
	columnsEnquiry,
	columnsPlaceBookingOff,
	columnsPlaceKey,
	columnsFaqs,
	columnsBookingHistory,
	columnsAvailableTicket,
	eRikshawBookingHistory,
	columnsBookingUpcomingWithCheckbox,
	columnsTestimonial,
	columnSalesReport,
	columnGstReport,
	columnPurchaseReport,
	columnCommissionReport,
	columnCancelReport,
	columnAttractionReport,
	columnBookingReviewList,
	columnsPendingSettlement,
	columnsProgressSettlement,
	columnsDailySettlementHistory,
	columnsAccountMainGroup,
	columnsAccountSubGroup,
	columnsAccountLedger,
	columnsOtherSOUBooking
};

export const columnsOptionalAttraction = [
	{
		key: "attractionName",
		label: "Attraction Name",
		render: (item) => item.attractionName,
	},
	{
		key: "variationId",
		label: "Variation ID",
		render: (item) => item.variationId || "—",
	},
];

export const columnsSitemap = [
	{
		key: "url",
		label: "URL Path",
		render: (item) => item.url,
	},
	{
		key: "sitemapType",
		label: "Sitemap Type",
		render: (item) => {
			const labels = {
				pages: "Pages",
				tickets: "Tickets/Places",
				packages: "Packages",
				blogs: "Blogs",
				hotels: "Hotels",
			};
			return labels[item.sitemapType] || item.sitemapType;
		},
	},
	{
		key: "changefreq",
		label: "Change Frequency",
		render: (item) => item.changefreq,
	},
	{
		key: "priority",
		label: "Priority",
		render: (item) => item.priority,
	},
];
